import { inject, Service } from '@angular/core';
import { ApiPrefixes } from '@workspace/data-types';
import { ApiCaller } from './api-caller.service';
import {
  BusinessConnector,
  NotificationsConnector,
  PublicConnector,
  UserSessionsConnector,
} from './connectors';
import { AdminConnector } from './connectors/admin/admin.connector';
import { AuthConnector } from './connectors/auth/auth.connector';
import { TokenVaultsConnector } from './connectors/token-vaults/token-vaults.connector';
import { UserConnector } from './connectors/users/user/user.connector';
import { UsersConnector } from './connectors/users/users.connector';

@Service()
export class ApiService {
  apiCaller = inject(ApiCaller);

  auth = () => new AuthConnector(this.apiCaller, ApiPrefixes.AUTH);
  public = () => new PublicConnector(this.apiCaller, ApiPrefixes.PUBLIC);
  users = () => new UsersConnector(this.apiCaller, ApiPrefixes.USER);
  user = () => new UserConnector(this.apiCaller, ApiPrefixes.USER);
  userSessions = () => new UserSessionsConnector(this.apiCaller, ApiPrefixes.USER);
  notifications = () => new NotificationsConnector(this.apiCaller, ApiPrefixes.USER);
  admin = () => new AdminConnector(this.apiCaller, ApiPrefixes.ADMIN);
  tokenVaults = () => new TokenVaultsConnector(this.apiCaller, ApiPrefixes.USER);
  business = () => new BusinessConnector(this.apiCaller, '');
}
